import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { AlertOptions } from '../confirmation-dialog.interfaces';
import { ConfirmationDialogComponent } from '../confirmation-dialog.component';
import { merge, cloneDeep } from 'lodash-es';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationDialogService {
    defaultDialogConfig = {
        autoFocus: false,
        minWidth: '375px',
        panelClass: 'dialog-rouded-edges',
        disableClose: true,
        restoreFocus: false
    }

    constructor(private _dialog: MatDialog) { }

    alert(options: AlertOptions, dialogConfig?: Partial<MatDialogConfig>) {
        const config = cloneDeep(this.defaultDialogConfig);
        if (dialogConfig) {
            merge(config, dialogConfig)
        }
        const alert = this._dialog.open(ConfirmationDialogComponent, config);
        alert.componentInstance.options = options;
        alert.componentInstance.overlayContainer.getContainerElement().classList.add(options.class);
        return alert;
    }

}
